import { HubspotIcon } from "#components/ui/HubspotIcon.tsx";
import { IconAssets } from "#types/assets.ts";
import type { IntegrationManifest } from "./types.ts";

export const hubspotManifest: IntegrationManifest = {
    key: "hubspot",
    displayName: "HubSpot",
    nameKey: "channels.hubspot",
    descriptionKey: "hubspotDescription",
    trayDescriptionKey: "composerTrayDescriptions.hubspot",
    cardDescriptionKey: "connectIntegration.descriptions.hubspot",
    connectedContentKeys: ["hubspotRecords"],
    brandColor: "#FF7A59",
    iconUrl: IconAssets.Hubspot,
    iconUrlAlt: IconAssets.HubspotAlt,
    glyph: HubspotIcon,
    channelType: "UserHubspotMcp",
    // Remote-MCP citations resolve via customProperties.integrationKey, not a DataSource.
    dataSources: []
};
